import { render, staticRenderFns } from "./ChainBPBar.vue?vue&type=template&id=3d7c8b69"
import script from "./ChainBPBar.vue?vue&type=script&lang=js"
export * from "./ChainBPBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports